/* global jQuery */

/*eslint-disable*/
function bootstrap() {
    let width;

    /*
     * load trigger
     */
    jQuery(document).ready(function () {
        onLoad();
        onResizeAndOrientationchange();
    });

    /*
     * trigger
     */
    function onLoad() {
        width = window.innerWidth;
        header.init();
        giraSlider.init();
        textChange.init();
        topLink.init();
        tabSlider.init();
        customSelect.init();
        gallery.init();
        video.init();
        form.init();
    }

    function onResizeAndOrientationchange() {
        jQuery(window).on('resize orientationchange', function () {
            if (width !== window.innerWidth) {
                width = window.innerWidth
            }
        });
    }
}
bootstrap();
